<div class="wrapper">
    <!-- [ngClass]="{ 'border-radius-none': statusTab === 1 }" -->
    <div class="header">
        <div class="header__tags-filial">
            <h2 *ngIf="!isMobile" class="header__title">Запись к врачу</h2>
            <div
                class="header__tabs"
                [ngClass]="{ 'tab-right': statusTab == 1 }"
                *ngIf="isFilialMode"
            >
                <button
                    class="toggle-btn toggle-btn__to-filial"
                    [ngClass]="{ 'toggle-btn__active': statusTab == 0 }"
                    (click)="changeTab(0)"
                >
                    <div class="toggle-btn__icon">
                        <mat-icon
                            class="toggle-btn__icon"
                            svgIcon="facility"
                        ></mat-icon>
                    </div>
                    <span class="toggle-btn__text">
                        {{ isMobile ? 'Филиалы' : 'По филиалу' }}</span
                    >
                </button>
                <button
                    class="toggle-btn toggle-btn__to-spec"
                    [ngClass]="{ 'toggle-btn__active': statusTab == 1 }"
                    (click)="changeTab(1)"
                >
                    <div class="toggle-btn__icon">
                        <mat-icon
                            class="toggle-btn__icon"
                            svgIcon="doctor"
                        ></mat-icon>
                    </div>
                    <span class="toggle-btn__text">
                        {{
                            isMobile ? 'Специальности' : ' По специальности'
                        }}</span
                    >
                </button>
            </div>
        </div>
        <div
            class="filter-wrapper"
            (click)="toggleSearchList($event)"
        >
            <mat-icon svgIcon="search" class="filter-wrapper__icon"></mat-icon>
            <input
                type="text"
                class="filter-wrapper__input"
                [placeholder]="
                    statusTab == 0 && !selectedFilial
                        ? 'Выберите филиал'
                        : 'Выберите специализацию'
                "
                #InputBlocSpec
                [(ngModel)]="searchStr"
                (ngModelChange)="changeSearch($event)"
            />
            <button
                class="filter-wrapper__clear"
                (click)="clearSearch($event)"
                *ngIf="searchStr.length > 0"
            >
                <img
                    src="./assets/icons/actions/close.svg"
                    alt="Clear"
                    width="16px"
                    height="16px"
                />
            </button>

            <!-- //меню для телефона -->
            <div
                class="mobile-filter"
                *ngIf="
                    !selectedSpec &&
                    staticFilterBTNs.length > 0 &&
                    statusTab === 1
                "
            >
                <button
                    class="mobile-filter__button"
                    (click)="mobileFilterHandler()"
                    [ngClass]="{ 'border-active': staticFilterSelected }"
                >
                    <img
                        src="./assets/icons/actions/filter.svg"
                        alt="filter"
                        [ngClass]="{ 'border-active': staticFilterSelected }"
                        class="mobile-filter__button-swg"
                        *ngIf="!staticFilterSelected"
                    />
                    <img
                        src="./assets/icons/actions/filter-active.svg"
                        alt="filterAccepted"
                        [ngClass]="{ 'border-active': staticFilterSelected }"
                        class="mobile-filter__button-swg"
                        *ngIf="staticFilterSelected"
                    />
                </button>
                <div class="dropdown-menu" *ngIf="isMobileFlilterOpen">
                    <app-filter-component
                        [staticFilterSelected]="staticFilterSelected"
                        [filterList]="staticFilterBTNs"
                        (filterChanged)="onFilterChanged($event)"
                        (closeFilter)="isMobileFlilterOpen = false"
                        [searchAmine]="searchAmine"
                        class="dropdown-menu"
                    ></app-filter-component>
                </div>
            </div>
        </div>
    </div>

    <div class="selection-panel" *ngIf="statusTab === 0">
        <div class="header__tags" *ngIf="selectedFilial || selectedSpec">
            <span class="header__label">
                <ng-container *ngIf="selectedFilial && selectedSpec">
                    <span
                        class="current-selection"
                        (click)="goBackToFilial()"
                        >{{ selectedFilial.depName }}</span
                    >
                    <span class="current-selection__devider">
                        <mat-icon
                            svgIcon="next-step"
                            class="current-selection__devider"
                        ></mat-icon>
                    </span>
                    <span
                        class="current-selection"
                        (click)="clearSelection()"
                        >{{ selectedSpec.text }}</span
                    >
                </ng-container>
                <ng-container *ngIf="selectedSpec && !selectedFilial">
                    <span
                        class="current-selection"
                        (click)="clearSelection()"
                        >{{ selectedSpec.text }}</span
                    >
                </ng-container>
                <ng-container *ngIf="selectedFilial && !selectedSpec">
                    <span
                        class="current-selection"
                        (click)="goBackToFilial()"
                        >{{ selectedFilial.depName }}</span
                    >
                </ng-container>
            </span>
        </div>

        

        <div class="selection-panel__wrapper">
            <div
                class="list-content filial-list"
                (click)="$event.stopPropagation()"
                *ngIf="
                    isFilialListVisible &&
                    filialList.length !== 0 &&
                    !selectedFilial
                "
                [class.slide-top]="isSearchListVisible"
                [class.slide-down]="!isSearchListVisible"
            >
                <div
                    class="list-content__item"
                    *ngFor="let fl of filialList"
                    (click)="selectFil(fl.depId)"
                >
                    <img
                        placeholder="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAyCAYAAAAN6MhFAAAC20lEQVRoBe1a3W3bMBD2CNmgHcEbNBs0G6Qb1Bu4G6QbdIQ8WST64qfUIgNUI5zVAn3NCC6OFJkTJcqkHCqmIAOE+Cfyvvuo4/Ho1WrCHzvAR17WXzFhfsKpp5nqsYIbJuAbE3CiqfgFm2kkmGAWdoBbJgAoQJMvBLygEiYQI90UCKCQ8N2AMs9CwgMmU2aivk8nReKRPSxCIf9+wqmZqLdZAx1ikS7RrIGeY5EuoiyBhrKYNdAYFrMEOobF7ICOZTEboJeymAXQt2DxqoG+JYtXCxRB9vio1ruhgsfmr2ofZQf48uqmqVPHFsHHgurrT4HupD6y4bFtbOqbI7iOyePeAj3AbfCLAR0pUDuHc4SLrIdCwF3A1N0uFOju978P3R7jaxIA1efcMYRMCBRYedxflMxqKOsf0eqfDuhl51H1XVugsM8SqAZRb/HpA5AcqNpjBdz5hPj5BGufgWh/o35GyfYG7wbUCiG7ywXBcwEvjeXcukJGALXBNHcMU07OKDH/HW03LqMWssdADAFtBO8NpinlOss4X6CteFI7PKqVW7dWSL5A0UPyhEdnxaj59vBJPo8Traf55IxyCZUSpOwao30FN8YY4fUDFUwDCAt3EmY7dsCMmRwoTsCf/3z2OfrYbuK4RijzHDJGpg8+NYh33kepQLH5UKAh4yZnNEQIX58FqE8zA/ULowPKaTUtp5eWOsYVsvpGeQmbQkLlu7XGFYHtuydYu+rICijxWjqb+SVOvauUc+XkxmgBqj0a/N/CqGPaOQbd9oVRVyO+8rntxTrtAip3jJ2E9WwYLUrYqBCl518lXMIDF8dHXFquIrKyuq7wMeUFaIy2mr7JjdEImewrC6NWFeGZKEaVJ4PXhCRxedShEgEnrq/2Wu20b2xeGSmyz8a+T/sro2jGwqAawdDk9U2gKrx2tAFjuz3Moq2+X6n/zs4CTF8M2NQ11x6aVYzMzS+ZKOR/ULSW8/yF0/AAAAAASUVORK5CYII="
                        class="list-content__item-icon"
                        [ngSrc]="getImgSrcFilials(fl.depId)"
                        (error)="errorHandlerIMG($event, 'filial')"
                        width="48"
                        height="48"
                    />
                    <span class="list-content__item-text">{{
                        fl.depName
                    }}</span>
                </div>
            </div>

            <div
                class="list-content float-up-animation"
                (click)="$event.stopPropagation()"
                *ngIf="
                    selectedFilial &&
                    !isLoading &&
                    !openMobileTemplate &&
                    specByFilialList.length > 0 &&
                    isSearchListVisible
                "
                [class.slide-top]="isSearchListVisible"
                [class.slide-down]="!isSearchListVisible"
            >
                <div
                    class="list-content__item"
                    *ngFor="let sfl of specByFilialList"
                    (click)="selectSpec(sfl.keyId, sfl.depid)"
                >
                    <img
                        placeholder="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAsCAYAAAD4rZFFAAADsklEQVRYCe1Zy3HbMBB1Ce4gLsEd2B3YHTgdyB04HSgd6BAT1CWjYyYiIJagS8YCpZmwBJWg5C2wIMghRRIEb/aMh5BAPLxdYL+6uYnwl2aHxyQ7fBNSb1KlSyH1hf5VcRZS74XSyzQ/3EXYajgESK3z4wKbC0PEkGJyHU8IMnyXwDdBLpU6d5qqyOQi08v17vSUqL9ffHixOz0ksljxmlmJiky/8kZCFmciJY+LJimfoD9Otsd7Wif15Ud2ePTnooxxn5hgooq3UNBUFW8WJw/F6FwnZLEH+BSCAF/l5S3hSH1e5fvbzg3HTiQ5jomstRy7tu19J/D2z33bfNB3QhbPluQmCKCxSKhiA7x1pp8aU+EfE3X4ClDcp3CUamWq2NKLl+rbiaNPkhMV6Jaz24h/3HoTJVTaeEwhbwaSF6F0OckVmQhhEgX4x9Umjl9b/TrcIXxGcUVsMMhs3NlHHDgr350egmGZZCqLVTDIlYWfJK8oZ9RUVE3OdSc5PCLfHCWd/7LJWCj9J1eBLNyfDx3btI/iN8ItrD0Ui9ZZN+RqlklgdjGye5uwTE79anzgdAH8s1Ea1F4a+IG9RvRrxPcnRnoVO8w63azlcUFHFOFeukJuisE4Zt6Aa5xkYtrPOGQwMcsH5ipsKTsl0RDquARBlLiMG/WJMtRsEFZEkRatAU52O9ckE9LUJ9Dqtffa5jjCzKZF3tSWpMZvjjAiLy8tZ9UiE/U7EdSg6mlEJVJ/J8+AzsXvj2fGmf1Zi0S4Z3nxgjvHGyPbbvaN3mXE6pA36nvi2Lw7aksMXdZaf7apAKH68ILmoQ2095D0oseIzS2B/Xv28cqgVdfMJiNepw1BgMsO4OFuMg49jVvbNE+CsTufDNbbdwRp74gBCEJtXTZKKvzmaiVI1ddUuhzUFqS+Tx0sh5TYmP9NEeV3c/USgrVJje/Z9VjjyUnzjLc93idb6pBUPc8W4R22cbbuyPI+V4EKkq2WsqS8bhjUz3Rd4OL8P6Qu3GYtA3PHrfBtRP1okKjhIcsaD7UFQRhaa1o1HH+fwMzZJtqMVw8YfCRJpve8YMzTHplLjq2Gy5DSwAqOHwQuuGrEg7RoL/JQidsEwFrXG1d6yVbdfBdJBix7vetu/VmhYVRGm5wpzx5TLVs+NdHj3Gv9dU5CY2TdTa35nyty9jcedkMdyW+V1unFDTPuciP+RlPGY0nyCVMHhd3IFAJj1lZk6y6riVFrgwtJvilK0765UdvnoSQ5LYQ//gd6DCZkSaeDpwAAAABJRU5ErkJggg=="
                        class="list-content__item-icon"
                        [ngSrc]="getImgSrcSpec(sfl.keyId)"
                        (error)="errorHandlerIMG($event, 'spec')"
                        width="48"
                        height="48"
                    />
                    <span class="list-content__item-text">{{ sfl.text }}</span>
                </div>
            </div>

            <div
                class="spec-list"
                *ngIf="
                    !isLoading && ((recDoctors !== null && recDoctors.length === 0) || specByFilialList.length === 0)
                "
            >
                Список пуст

                <div
                    class="spec-list__return-to-filials"
                    (click)="
                        selectedFilial && searchStr.length !== 0
                            ? clearSearch()
                            : goBackToFilial()
                    "
                >
                    Вернуться к списку
                    {{
                        selectedFilial &&
                        specByFilialList.length === 0 &&
                        searchStr.length !== 0
                            ? 'специальностей'
                            : 'филиалов'
                    }}
                </div>
            </div>

            <div *ngIf="isLoading" class="loader-container">
                <loader type="page" message="Загружаем..."> </loader>
            </div>

            <div class="doctors-list" *ngIf="selectedSpec && !isLoading">
                <ng-container *ngFor="let doctor of recDoctors">
                    <app-doctor-card
                        *ngIf="!isDropdownOpen"
                        [doctor]="doctor"
                        [isActive]="doctor === activeItem"
                        [openSelectStates]="openSelectStates"
                        [selectedSrvMap]="selectedSrvMap"
                        [searchStrSrv]="searchStrSrv"
                        (serviceSelected)="selectService($event)"
                        (toggleSelectEvent)="handleToggleSelect($event)"
                        (searchSrvChanged)="handleSearchSrvChanged($event)"
                        (openDocInfo)="handleOpenDocInfo($event)"
                        (openServDesc)="handleOpenServDesc($event)"
                        (pickDoc)="pickDoc($event)"
                        style="display: block; width: 100%"
                        [isMobile]="isMobile"
                    ></app-doctor-card>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="selection-panel" *ngIf="statusTab == 1">
        <div class="header__row" *ngIf="!isMobile">
            <div class="header__tags">
                <button
                    class="filter-button"
                    *ngFor="let fl of staticFilterBTNs"
                    (click)="btnStaticFiltr(fl); $event.stopPropagation()"
                    [ngClass]="{
                        'filter-button__active':
                            fl.keyId === staticFilterSelected,
                    }"
                    [disabled]="isLoading"
                >
                    <span>{{ fl.text }}</span>
                </button>
            </div>
        </div>

        

        <div class="selection-panel__wrapper">
            <div *ngIf="isLoading || isSpecLoading" class="loader-container">
                <loader type="page" message="Загружаем..."> </loader>
            </div>
            <div
                class="list-content"
                (click)="$event.stopPropagation()"
                *ngIf="
                    !isSpecLoading &&
                    isSearchListVisible &&
                    specList.length > 0 &&
                    statusTab === 1
                "
                [class.slide-top]="isSearchListVisible"
                [class.slide-down]="!isSearchListVisible"
            >
                <div
                    class="list-content__item"
                    *ngFor="let sl of specList"
                    (click)="selectSpec(sl.keyId, null)"
                >
                    <img
                        placeholder="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAsCAYAAAD4rZFFAAADsklEQVRYCe1Zy3HbMBB1Ce4gLsEd2B3YHTgdyB04HSgd6BAT1CWjYyYiIJagS8YCpZmwBJWg5C2wIMghRRIEb/aMh5BAPLxdYL+6uYnwl2aHxyQ7fBNSb1KlSyH1hf5VcRZS74XSyzQ/3EXYajgESK3z4wKbC0PEkGJyHU8IMnyXwDdBLpU6d5qqyOQi08v17vSUqL9ffHixOz0ksljxmlmJiky/8kZCFmciJY+LJimfoD9Otsd7Wif15Ud2ePTnooxxn5hgooq3UNBUFW8WJw/F6FwnZLEH+BSCAF/l5S3hSH1e5fvbzg3HTiQ5jomstRy7tu19J/D2z33bfNB3QhbPluQmCKCxSKhiA7x1pp8aU+EfE3X4ClDcp3CUamWq2NKLl+rbiaNPkhMV6Jaz24h/3HoTJVTaeEwhbwaSF6F0OckVmQhhEgX4x9Umjl9b/TrcIXxGcUVsMMhs3NlHHDgr350egmGZZCqLVTDIlYWfJK8oZ9RUVE3OdSc5PCLfHCWd/7LJWCj9J1eBLNyfDx3btI/iN8ItrD0Ui9ZZN+RqlklgdjGye5uwTE79anzgdAH8s1Ea1F4a+IG9RvRrxPcnRnoVO8w63azlcUFHFOFeukJuisE4Zt6Aa5xkYtrPOGQwMcsH5ipsKTsl0RDquARBlLiMG/WJMtRsEFZEkRatAU52O9ckE9LUJ9Dqtffa5jjCzKZF3tSWpMZvjjAiLy8tZ9UiE/U7EdSg6mlEJVJ/J8+AzsXvj2fGmf1Zi0S4Z3nxgjvHGyPbbvaN3mXE6pA36nvi2Lw7aksMXdZaf7apAKH68ILmoQ2095D0oseIzS2B/Xv28cqgVdfMJiNepw1BgMsO4OFuMg49jVvbNE+CsTufDNbbdwRp74gBCEJtXTZKKvzmaiVI1ddUuhzUFqS+Tx0sh5TYmP9NEeV3c/USgrVJje/Z9VjjyUnzjLc93idb6pBUPc8W4R22cbbuyPI+V4EKkq2WsqS8bhjUz3Rd4OL8P6Qu3GYtA3PHrfBtRP1okKjhIcsaD7UFQRhaa1o1HH+fwMzZJtqMVw8YfCRJpve8YMzTHplLjq2Gy5DSwAqOHwQuuGrEg7RoL/JQidsEwFrXG1d6yVbdfBdJBix7vetu/VmhYVRGm5wpzx5TLVs+NdHj3Gv9dU5CY2TdTa35nyty9jcedkMdyW+V1unFDTPuciP+RlPGY0nyCVMHhd3IFAJj1lZk6y6riVFrgwtJvilK0765UdvnoSQ5LYQ//gd6DCZkSaeDpwAAAABJRU5ErkJggg=="
                        class="list-content__item-icon"
                        [ngSrc]="getImgSrcSpec(sl.keyId)"
                        (error)="errorHandlerIMG($event, 'spec')"
                        width="48"
                        height="48"
                    />
                    <span class="list-content__item-text">{{ sl.text }}</span>
                </div>
            </div>

            <div
                class="spec-list"
                *ngIf="
                    specList.length === 0 && !isSpecLoading && statusTab === 1
                "
            >
                Список пуст
            </div>
            
            <div class="doctors-list" *ngIf="selectedSpec && !isLoading">
                <ng-container *ngFor="let doctor of recDoctors">
                    <app-doctor-card
                        *ngIf="!isDropdownOpen"
                        [doctor]="doctor"
                        [isActive]="doctor === activeItem"
                        (serviceSelected)="selectService($event)"
                        [openSelectStates]="openSelectStates"
                        [selectedSrvMap]="selectedSrvMap"
                        [searchStrSrv]="searchStrSrv"
                        (toggleSelectEvent)="handleToggleSelect($event)"
                        (searchSrvChanged)="handleSearchSrvChanged($event)"
                        (openDocInfo)="handleOpenDocInfo($event)"
                        (openServDesc)="handleOpenServDesc($event)"
                        (pickDoc)="pickDoc($event)"
                        style="display: block; width: 100%"
                        [isMobile]="isMobile"
                    ></app-doctor-card>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showMobileServiceList && isMobile" class="doctor__srvlist">
    <rec-mobile-docsrv-list
        class="doctor__srvlist"
        [srvList]="selectedDoctor?.srvList || []"
        (srvChanged)="srvChanged($event)"
        (closeSrvList)="closeMobileServiceList()"
    ></rec-mobile-docsrv-list>
</div>

<div *ngIf="showMobilePicker && isMobile" class="mobile-template">
    <app-mobile-appointment
        [params]="paramsTalonpicker"
        (talonPickerClosed)="onTalonPickerClosed()"
    ></app-mobile-appointment>
</div>
<div
    *ngIf="showCalendar || loadingCalendar"
    class="cls-date-rnum"
    [class.visible]="showCalendar"
>
    <app-talonpicker
        #talonPicker
        *ngIf="showCalendar"
        [params]="paramsTalonpicker"
        (talonPickerClosed)="onTalonPickerClosed()"
    ></app-talonpicker>
</div>
